import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import { ROUTES } from './paths';
import { LoadingState } from '../components/ui/PageState';
import type { RoleName } from '../types/api';

interface ProtectedRouteProps {
  /** Si se omite, basta con estar autenticado. */
  roles?: RoleName[];
}

export function ProtectedRoute({ roles }: ProtectedRouteProps): ReactNode {
  const { isAuthenticated, isBootstrapping, user } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div className="grid min-h-dvh place-items-center">
        <LoadingState label="Recuperando la sesión" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={ROUTES.forbidden} replace />;
  }

  return <Outlet />;
}
